// src/services/ratechart.js
import { api, extractJsonObject } from "./api";

/** Server sometimes returns raw string / BOM / extra garbage like Android */
function parseServerData(data) {
  if (data == null) return null;
  if (typeof data === "object") return data;

  const cleaned = extractJsonObject(String(data));
  try {
    return JSON.parse(cleaned);
  } catch {
    return { ok: false, msg: String(data) };
  }
}

// POST: save ratechart
export async function saveRatechart(envelope) {
  if (!envelope || typeof envelope !== "object") {
    throw new Error("Envelope missing");
  }
  if (!envelope.payload) {
    throw new Error("Envelope.payload missing");
  }

  // make sure it's JSON-serializable (also helps catch undefined)
  JSON.stringify(envelope);

  const resp = await api.post("save_ratechart.php", envelope, {
    headers: { "Content-Type": "application/json" },
  });

  const parsed = parseServerData(resp.data);
  if (!parsed?.ok) {
    throw new Error(parsed?.msg || "Save failed");
  }
  return parsed;
}

// GET: load ratechart
export async function getRatechart({ mainuser, type, ratechartno }) {
  console.log("getRatechart() ->", "get_ratechart.php", { mainuser, type, ratechartno });

  const resp = await api.get("get_ratechart.php", {
    params: {
      mainuser: mainuser || "",
      type: type || "",
      ratechartno: String(ratechartno || 1),
      _ts: String(Date.now()),
    },
  });

  const parsed = parseServerData(resp.data);

  if (parsed && (parsed.ok === false || parsed.status === "error")) {
    throw new Error(parsed.msg || parsed.message || "Load failed");
  }

  return parsed;
}
